<template>
  <div class="container-fluid newsSectionContainer">
    <div class="col">
      <div class="row newsSection">
        <div
          v-scrollanimation
          v-for="(item, idx) in newsData"
          :key="idx"
          class="newsSectionitem col-lg-6 col-xl-5"
        >
          <div>
            <router-link :to="item.Link">
              <div class="newsContent container">
                <div class="newsImg col">
                  <b-img :src="item.Img" fluid alt="Responsive image"></b-img>
                </div>
                <div class="col">
                  <h3>{{ item.Title }}</h3>
                  <p>{{ item.Description }}</p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import newsData from "./newsData.js";
export default {
  data: function() {
    return {
      newsData: newsData
    };
  }
};
</script>
<style scoped>
.newsSectionContainer {
  background-color: #ffffff;
}
.newsSection {
  display: flex;
  justify-content: center;
  padding: 1% 0%;
}
.newsSectionitem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
a,
p,
h3 {
  text-decoration: none !important;
}

.newsContent {
  padding: 5% 2%;
  display: flex;
  flex-basis: 100%;
  margin: 5% 2%;

  background-color: #eeeeee;
  transition: 0.6s;
  align-items: center;
  color: #000000;
}

.newsContent:hover {
  -webkit-box-shadow: 0 10px 6px -6px #777;
  -moz-box-shadow: 0 10px 6px -6px #777;
  box-shadow: 0 10px 6px -6px #777;
  background-color: rgb(15, 15, 15);

  text-decoration: none;
  color: white;
}
.newsImg {
  display: flex;
  justify-content: center;
  max-height: 11rem;
  max-width: 16rem;
}

@media (max-width: 576px) {
  .newsContent {
    flex-direction: column;
  }
  .newsImg {
    margin-bottom: 2%;
  }
}
</style>
